import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Box, Paper } from "@material-ui/core";
import { useTranslate } from 'react-admin';
import Button from "@material-ui/core/Button";
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
import {
    usePopupState,
    bindToggle,
} from 'material-ui-popup-state/hooks'
import colors from '../CustomizedUIs/Colors'

const useStyles = makeStyles(theme => ({

    typography: {
        padding: theme.spacing(2)
    },
    arrow: {
        position: "absolute",
        marginTop: '1em',
        fontSize: 15,
        width: "3em",
        height: "1em",

        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: 0,
            height: 0,
            borderStyle: "solid"
        }
    },
    popper: {
        zIndex: 100000,
        marginLeft: "1em",
        marginTop: '4em',
        width: 200,
        borderRadius: "10px",
        boxShadow: '0 10px 35px 0 rgba(0, 0, 0, 0.1), 0 15px 10px 0 rgba(0, 0, 0, 0.02)',
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: "-0.9em",
            height: "3em",
            width: "1em",
            "&::before": {
                borderWidth: "1em 1em 1em 0",
                borderColor: `transparent ${
                    theme.palette.background.paper
                    } transparent transparent`
            }
        },

    }
}));

export default function PositionedPopper({ isGenerated, isEdit, isDelete, icon, content }) {
    const popupState = usePopupState({ variant: 'popper', popupId: 'actionPopup' })
    const translate = useTranslate();
    React.useEffect(() => {
        if (isEdit || isDelete.status || isGenerated)
            popupState.close()
    }, [isEdit, isDelete,isGenerated])
    return (

        <div>
            <CustomPopoverArrow
                zIndex={10000}
                popupState={popupState}
                placement='right-start'
            >
                <Paper style={{ padding: 8 }}>
                    <Box>
                        {content}
                    </Box>
                    <Box display='flex' justifyContent='flex-end'>
                        <Button color='primary' onClick={popupState.close} size='small'>{translate(`pos.common.close`)}</Button>
                    </Box>

                </Paper>
            </CustomPopoverArrow>

            <IconButton {...bindToggle(popupState)} style={{ backgroundColor: 'white', width: 28, height: 28,padding:0, border: `solid 2px ${colors.lightBlue['100']}`, borderRadius: 10 }}>
                {icon}
            </IconButton>

        </div>

    );
}
